import { defineStore } from 'pinia';

interface Name {
  name?: string;
}
interface Path {
  path: string;
  query?: string;
  fullPath?: string;
  meta?: Name;
}
export const tagViewStore = defineStore('tagViewStore', {
  state: () => ({
    // 这里和后台约定好首页的path和对应的title，因为在tagsView中只有这两个属性是有用的
    homeView: { path: '' },
    visitedViews: new Array<Path>(),
    cachedViews: new Array<Path>(),

    // 父级router-view页面对应的组件name池
    fatherRoutePool: {},
    routerPool: {},
  }),
  actions: {
    setHomeView(view) {
      this.homeView = view;
    },
    addView(view) {
      this.addVisitedView(view);
      this.addCachedView(view);
    },
    addVisitedView(view) {
      if (!this.visitedViews.length) {
        this.setHomeView(view);
      }
      if (this.visitedViews.some(v => v.path === view.path)) return;
      this.visitedViews.push(Object.assign({}, view));
    },
    addCachedView(view) {
      if (this.cachedViews.includes(view.name)) return;
      this.cachedViews.push(view.name);
    },
    deleteView(view) {
      this.deleteVisitedView(view);
      this.deleteCachedView(view);
    },
    deleteVisitedView(view) {
      for (const [i, v] of this.visitedViews.entries()) {
        if (v.path === view.path) {
          this.visitedViews.splice(i, 1);
          break;
        }
      }
    },
    deleteCachedView(view) {
      const index = this.cachedViews.indexOf(view.name);
      index > -1 && this.cachedViews.splice(index, 1);
    },
    deleteOtherViews(view) {
      return new Promise(resolve => {
        this.deleteOtherVisitedViews(view);
        this.deleteOtherCachedViews(view);
        resolve(true);
      });
    },
    deleteOtherVisitedViews(view) {
      this.visitedViews = this.visitedViews.filter(o => o.path === this.homeView.path || o.path === view.path);
    },
    deleteOtherCachedViews(view) {
      const index = this.cachedViews.indexOf(view.name);
      if (index > -1) {
        this.cachedViews = this.cachedViews.slice(index, index + 1);
      } else {
        this.cachedViews = [];
      }
    },
    deleteAllViews() {
      return new Promise(resolve => {
        this.deleteAllVisitedViews();
        this.deleteAllCachedViews();
        resolve(true);
      });
    },
    deleteAllVisitedViews() {
      this.visitedViews = this.visitedViews.filter(o => o.path === this.homeView.path);
    },
    deleteAllCachedViews() {
      this.cachedViews = [];
    },
    // 更新visitedView
    updateVisitedView(view) {
      for (let v of this.visitedViews) {
        if (v.path === view.path) {
          v = Object.assign(v, view);
          break;
        }
      }
    },
    clearHomeView() {
      this.homeView = {};
    },
  },
});
